import { render } from "./ProductSetItemDetails.vue?vue&type=template&id=76cf82f0"
import script from "./ProductSetItemDetails.vue?vue&type=script&lang=js"
export * from "./ProductSetItemDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__